import axios from 'axios'

const api = axios.create({
  baseURL: 'https://viacep.com.br/ws',
})

api.interceptors.response.use(
  (res) => {
    return Promise.resolve(res)
  },
  (error) => {
    if (error instanceof axios.Cancel) {
      const err = error
      err.message = 'Cancelado pelo usuário'
      return Promise.reject(err)
    }

    const res = error.response

    if (!res) {
      return Promise.reject()
    }
    return Promise.reject(res)
  },
)

export default api
